<template>
  <div class="screen-tree" style="height: 100%;" v-if="treeData" v-loading="isLoading">
    <div class="tree-head">
      <el-input
        placeholder="输入关键字进行过滤"
        size="small"
        v-if="screenInfo.isAppenSearchInput"
        @keyup.enter="$refs.tree.filter(filterText)"
        v-model="filterText">
      </el-input>
      <el-icon class="el-icon-refresh-right" @click="getTreeData">
        <RefreshRight />
      </el-icon>
    </div>
    <!-- 编辑模式下不显示全选 -->
     <!-- 暂时注释 -->
      <!-- v-model="screenInfo.checkAll"  -->
    <el-checkbox 
      v-if="!isEdit && screenInfo.isAppenAll"
      style="height: 40px;line-height: 40px;margin-left: 10px;" 
      @change="checkChange"
      >
      <span :style="fontStyle">全部</span>
    </el-checkbox>
    <el-tree
      v-if="!isLoading"
      @node-click="handleNodeClick"
      @node-expand="(data) => { handleNodeExpand(data) }"
      @check="handleNodeCheck"
      :data="treeData"
      :show-checkbox="screenInfo.filterMode === 'multiple' ? true : false"
      :highlight-current="screenInfo.filterMode === 'multiple' ? false : true"
      :default-checked-keys="defaultCheckedKeys"
      :current-node-key="currentNodeKey"
      :default-expanded-keys="[currentNodeKey]"
      node-key="id"
      ref="tree"
      :filter-node-method="filterNode"
      :props="defaultProps">
      <template v-slot="{ node, data }">
        <span class="custom-tree-node">
          <i class="el-icon-loading" v-if="data.isLoading"></i>
          <optionItem
            :selInfo="node.data.fieldValue"
            :treeLevel="node.level"
            :info="screenInfo"
            :tickList="tickLevel[node.level]"
            :styleInfo="fontStyle"
            @todo-inside="$emit('todo-inside', $event)"
            @todo-outside="$emit('todo-inside', $event)"
            @custom-scene="$emit('custom-scene',$event)"
            @to-nav="$emit('to-nav', $event)"
            @open-appDialog="$emit('open-appDialog', $event)"
            @open-dictionary="$emit('open-dictionary',$event)"
          />
        </span>
      </template>
    </el-tree>
  </div>
</template>

<script>
import { getData } from './utils/utils.js'
import { cloneDeep } from 'lodash'
import optionItem from './optionItem.vue'
import { isObject } from 'lodash';
import { getRandom } from '@/components/admins/workBench/moreSetting/mycomponent/batchAddition/utils.js'
export default {
  name: 'screenTree',
  data () {
    return {
      treeData: [],
      initTreeData: [], // 初始化的时候生产的数据
      defaultCheckedKeys: [],
      currentNodeKey: -1,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      checkList: [],
      isLoading: false,
      filterText: '',
      id: 0,
      obj: {
        color: ''
      },
      filterValueObj: {

      },
      tableData: {},
      breadList: [],
      tickLevel: {}, // 选中列表
      defaultSelected: '', // 默认选中
      filterList: [],
      screenLevelData: []
    }
  },
  props: {
    screenInfo: {
      type: Object,
      default: () => {}
    },
    levelList: {
      type: Array,
      default: () => []
    },
    inputAppenText: {
      type: Array,
      default: () => []
    },
    isView: {
      type: Boolean,
      default: false
    },
    fontStyle: {
      type: Object,
      default: () => {}
    },
    getScreenList: {
      type: Function,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    customDeskId: {
      type: [Number, String],
      default: 0,
    },
    customData: {
      type: Array,
    },
    screenRefInfoValue: {
      type: Array,
      default: () => { return [] }
    },
    // 是否是门户明细表
    isInDetailed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    optionItem
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    },
    'screenInfo.filterList': {
      handler (val) {
        if (val && Array.isArray(val)) {
          this.filterList = cloneDeep(val)
          const { screenLevel, filterMode } = this.screenInfo
          const isData = val.findIndex(item => { return item })
          if (isData !== -1) {
            val.forEach((item, i) => {
              if (typeof item === 'string') {
                // 兼容旧配置
                const [ title, name, type ] = item.split('_')
                const id = getRandom(100, 100000)
                const { field } = this.screenInfo.screenLevel.levelList[i]

                const [ screenTitle, screenType  ] = field.split('_')
                const obj = {
                  id,
                  sourceField: `${title}_${name}_${type}`,
                  screenField: `${screenTitle}_${screenType}`
                }
                this.filterList[i] = [obj]
              } else if (Array.isArray(item)) {
                item.forEach((iten, itenIndex) => {
                  if (iten.sourceField) {
                    // 获取筛选对象的格式
                    const sourceFieldItem = this.screenInfo.datas.find(iter => { return iter.title === iten.sourceField })
                    if (sourceFieldItem) {
                      this.filterList[i][itenIndex].sourceField = `${sourceFieldItem.title}_${sourceFieldItem.type}`
                    }
                  }
                  if (iten.screenField && this.screenInfo.screenLevel.levelList[i]) {
                    // 获取筛选值字段的格式
                    const { dataInfo } = this.screenInfo.screenLevel.levelList[i]
                    const screenFieldItem = dataInfo.allData.find(iter => { return iter.title === iten.screenField })
                    if (screenFieldItem) {
                      this.filterList[i][itenIndex].screenField = `${screenFieldItem.title}_${screenFieldItem.type}`
                    }
                  }
                })
              }
            })
          } else if (screenLevel.levelType === 'multiple' && filterMode === 'single') {
            // 兼容多级单选配置
            const field = `${this.screenInfo.title}_${this.screenInfo.checkName}_${this.screenInfo.screenType}`
            const index = this.levelList.length - 1
            // eslint-disable-next-line vue/no-mutating-props
            this.screenInfo.filterList[index] = field
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    getLevelTag() {
      const level = {}
      const li = this.getLevelList(this.treeData)
      li.forEach(item => {
        const [title] = this.levelList[item.level - 1].field.split('_')
        const data = item.data[title]
        if (level[item.level]) {
          if (isObject(data)) {
            // 暂时只有联系人
            const idx = level[item.level].findIndex(item => item.userId === data.userId)
            if (idx === -1) {
              if (Array.isArray(data)) {
                level[item.level].push(...data)
              } else {
                level[item.level].push(data)
              }
            }
          } else {
            if (!level[item.level].includes(data)) {
              if (Array.isArray(data)) {
                level[item.level].push(...data)
              } else {
                level[item.level].push(data)
              }
            }
          }
        } else {
          level[item.level] = Array.isArray(data) ? data : [data]
        }
      })
      return level
    },
    isSetTag () {
      let flag = false
      const index = this.levelList.findIndex(item => {
        return item.tagInfo !== undefined
      })
      if (index !== -1) {
        flag = true
      }
      return flag
    }
  },
  methods: {
    getLevelList(data = []) {
      const li = []
      data.forEach(item => {
        if (item.children) {
          const children = this.getLevelList(item.children)
          li.push(...children)
        }
        if (item.label) {
          li.push(item)
        }
      })
      return li
    },
    async getTickList() {
      if (!this.isSetTag) return false
      this.tickLevel = {}
      for (const tag in this.getLevelTag) {
        let filed = this.screenInfo.filterList[tag - 1]
        if (Array.isArray(filed)) {
          filed = filed[0] ? filed[0].sourceField : ''
        }
        if (filed) {
          const [title, , type] = filed.split('_')
          let li = []
          if (this.getScreenList) {
            li = await this.getScreenList({
              groupfield: `${title}_${type}`
            })
          }
          this.$set(this.tickLevel, tag, li)
        }
      }
    },
    checkChange (val) {
      if (val) {
        this.$refs.tree.setCheckedKeys([])
        this.getAllOptionsQuery()
      } else {
        // 取消全选传空值
        this.setFilterObj(false, [], [])
      }
    },
    filterNode (value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    async handleNodeExpand (nodeData, isInit = false) {
      // 点击的时候取获取下级的子节点
      // 已经展开过的就不要再请求数据了
      if (nodeData.isGetData) return false
      if (nodeData.children && nodeData.children.length > 0) {
        const index = nodeData.level
        const levelConfig = cloneDeep(this.levelList[index])
        // 标记一下已经展开过的
        nodeData.isGetData = true
        // 有配置再获取数据
        if (levelConfig) {
          await this.setChildren(nodeData, isInit, levelConfig, index)
        }
      }
    },
    async setChildren (nodeData, isInit = false, levelConfig, index) {
      this.currentNodeKey = -1
      nodeData.isLoading = true
      const { field, dataInfo, fatherFilterList } = levelConfig
      const loadingLevel = this.screenInfo.loadingLevel
      const fatherData = {}
      if (loadingLevel === 'one' && levelConfig.fatherFilterList.length > 0) {
        // 展开下级的时候要把父级的条件一起带下去查询
        const query = levelConfig.fatherFilterList.map(item => {
          const { currentField, fatherField } = item
          const fatherTitle = fatherField.split('_')[0]
          const obj = {
            title: currentField.title,
            type: currentField.type,
            condition: 'in',
            conditionValue: [nodeData.data[fatherTitle]]
          }
          fatherData[currentField.title] = nodeData.data[fatherTitle]
          return obj
        })
        if (levelConfig.rulerData.fixquery.linked === undefined) {
          levelConfig.rulerData.fixquery = {
            linked: [],
            ov: 'and'
          }
        }
        levelConfig.rulerData.fixquery.linked.push(...query)
      }
      const res = this.tableData[dataInfo.id] || await getData({ config: cloneDeep(levelConfig), loadingLevel, fatherData: fatherData, customDeskId: this.customDeskId, screenRefValue: this.screenRefInfoValue })
      // 一级加载的时候要一直请求接口
      if (loadingLevel !== 'one' && !this.tableData[dataInfo.id]) {
        this.tableData[dataInfo.id] = res
      }
      const title = dataInfo.datatype === 1 ? field.split('_')[0] : field.split('_')[1] // 当前表要使用的字段
      const type = field.split('_')[2] // 当前表要使用的字段类型
      const data = res.filter(item => {
        // 获取过滤条件
        const filterObj = {}
        if (Array.isArray(fatherFilterList)) {
          fatherFilterList.forEach(iten => {
            let value = this.getLabel((item[iten.currentField.title] || item[iten.currentField.name]),iten.currentField.type)
            filterObj[iten.fatherField] = value
          })
        }
        if (nodeData.data) {
          const flag = this.filterData(filterObj, nodeData)
          if (flag) return item
        }
      }).map(item => {
        let label = this.getLabel(item[title], type)
        if (Array.isArray(label)) {
          label = label.join()
        }
        const obj = {
          id: this.id++,
          label: label,
          level: index + 1,
          parentLable: nodeData.parentLable ? [...nodeData.parentLable] : [],
          data: item,
          datatype: dataInfo.datatype,
          fieldValue: item[title],
          fieldType: type,
          children: this.levelList.length === index + 1 ? [] : [{ label: '' }] // 层级和配置长度一样说明到最后一级了
        }
        obj.parentLable.push(nodeData.label) // 记录一下上级的值
        return obj
      })
      if (data.length > 0) {
        if (nodeData.children === undefined) {
          nodeData.children = []
        } else {
          if (!nodeData.children[0].label) {
            nodeData.children = []
          }
        }
        // 去除重复的选项
        const childrenData = this.uniqueByKey([...(nodeData.children || []), ...data], 'label')
        nodeData.children = childrenData
        if (isInit) {
          // 初始化未到最后一级还要展开
          this.currentNodeKey = childrenData[0].id
          this.handleNodeExpand(childrenData[0], true)
          if (this.levelList.length === index + 1) {
            if (this.defaultSelected === 'first') {
              // 到最后一级了 defaultSelected 为 first 要选中第一个
              this.$nextTick(()=>{
                this.$refs.tree.setCurrentKey(this.currentNodeKey);
                this.defaultCheckedKeys = [this.currentNodeKey]
                this.checkList.push(childrenData[0])
              })
            }
            setTimeout(() => {
              const checkedNodes = this.$refs.tree.getCheckedNodes()
              const halfCheckedNodes = this.$refs.tree.getHalfCheckedNodes()
              this.setFilterObj(false, checkedNodes, halfCheckedNodes)
            }, 100)
          }
        } 
        await this.getTickList()
      } else {
        if (isInit && this.defaultSelected === 'first') {
          // 没到到最后一级了但是没下级了
          setTimeout(() => {
            const halfCheckedNodes = this.$refs.tree.getHalfCheckedNodes()
            const checkedNodes = this.$refs.tree.getCheckedNodes()
            this.setFilterObj(false, checkedNodes, halfCheckedNodes)
          }, 10)
        }
        nodeData.children = null
      }
      nodeData.isLoading = false
      
    },
    uniqueByKey (arr, key) {
      const seen = new Set()
      return arr.filter((item) => {
        const serializedKey = JSON.stringify(item[key])
        return seen.has(serializedKey) ? false : seen.add(serializedKey)
      })
    },
    async handleNodeClick (data, node) {
      if (data.level !== this.levelList.length || this.screenInfo.filterMode !== 'single') {
        return false
      }
      this.breadList = []
      let selectNode = this.$refs.tree.getNode(node)
      // 获取当前节点的父级
      this.platform(selectNode)
      this.setFilterObj(false, this.breadList, [])
    },
    platform(node) {
      if (!node.parent) {
        return
      }
      this.breadList.unshift(node.data)
      //调用递归
      this.platform(node.parent)
    },
    handleNodeCheck (data, { checkedNodes, halfCheckedNodes }) {
      // eslint-disable-next-line vue/no-mutating-props
      this.screenInfo.checkAll = this.screenInfo.checkAll = false
      if (this.filterList && this.filterList.length > 0) {
        // 多对多筛选
        this.setFilterObj(false, checkedNodes, halfCheckedNodes)
      } else {
        if (data.level !== this.levelList.length) {
          return
        } else {
          const index = this.checkList.findIndex(item => { return data.label === item.label })
          const isCheck = checkedNodes.findIndex(item => { return data.label === item.label }) !== -1 ? true : false
          if (isCheck && index === -1) {
            this.checkList.push(data)
          } else if (!isCheck && index !== -1) {
            this.checkList.splice(index, 1)
          }
          this.checkList = Array.from(new Set(this.checkList))
          this.$emit('handleNodeCheck', this.checkList)
        }
      }
    },
    setFilterObj (isInit = false, checkedNodes, halfCheckedNodes) {
      const checkedList = [...checkedNodes, ...halfCheckedNodes]
      this.setScreenTreeCheckData(checkedList)
      const filterValueObj = {}
      const lableValueObj = {} // 选中的label
      if (this.filterList && this.filterList.length > 0) {
        this.filterList.forEach(item => {
          if (item && item.sourceField) {
            const [title, name, type] = item.sourceField.split('_')
            let key = this.isInDetailed ? title + '_' + type + '_' + item.id : title + '_' + type
            if (item.isCustom) {
              key += `_${name}`
            }
            filterValueObj[key] = []
          }
        })
        this.screenInfo.screenLevel.levelList.forEach(item => {
          if (item.field) {
            const [title, , type] = item.field.split('_')
            const key = `${title}_${type}`
            lableValueObj[key] = []
          }
        })
        checkedList.forEach(data => {
          // 设置筛选值
          const leveFilterlList = this.filterList[data.level - 1] || []
          leveFilterlList.forEach(leveFilterlItem => {
            if (leveFilterlItem && leveFilterlItem.sourceField) {
              const [title, name, type] = leveFilterlItem.sourceField.split('_')
              let key = this.isInDetailed ? title + '_' + type + '_' + leveFilterlItem.id : title + '_' + type
              if (leveFilterlItem.isCustom) {
                key += `_${name}`
              }
              const screenKey = leveFilterlItem.screenField
              if (filterValueObj[key] === undefined) filterValueObj[key] = []
              if (filterValueObj[key] && screenKey) {
                const [ screenKeyTitle, screenKeyType ] = screenKey.split('_')
                const value = data.data[screenKeyTitle]
                if (Array.isArray(value)) {
                  if (['relation-user', 'roule', 'organization'].includes(screenKeyType)) {
                    // 联系人、组织角色的处理
                    const val = value[0]
                    const i = filterValueObj[key].findIndex(item => {
                      return (item.userId && item.userId === val.userId) ||
                      (item.roleId && item.roleId === val.roleId) ||
                      (item.organizationId && item.organizationId === val.organizationId)
                    })
                    if (i === -1) {
                      filterValueObj[key].push(val)
                    }
                  } else {
                    filterValueObj[key].push(...value)
                  }
                } else if (['number'].includes(screenKeyType)) {
                  // 数字后端是区间搜索 所以把最小值和最大值取出来
                  const numberList = [ ...filterValueObj[key],  value]
                  if (numberList.length > 1) {
                    filterValueObj[key] = [ Math.min(...numberList), Math.max(...numberList) ]
                  } else {
                    filterValueObj[key].push(value)
                  }
                } else if(!filterValueObj[key].includes(value)) {
                  filterValueObj[key].push(value)
                }
              }
            }
          })

          // 设置lable obj
          const item = this.screenInfo.screenLevel.levelList[data.level - 1]
          if (item && item.field) {
            const key = `${item.field.split('_')[0]}_${item.field.split('_')[2]}`
            if (lableValueObj[key] === undefined) lableValueObj[key] = []
            if (lableValueObj[key]) {
              if (['relation-user', 'roule', 'organization'].includes(data.fieldType)) {
                // 联系人、组织角色的处理
                const val = data.fieldValue[0]
                const i = lableValueObj[key].findIndex(item => {
                  return (item.userId && item.userId === val.userId) ||
                    (item.roleId && item.roleId === val.roleId) ||
                    (item.organizationId && item.organizationId === val.organizationId)
                })
                if (i === -1) {
                  lableValueObj[key].push(val)
                }
              } else if(!lableValueObj[key].includes(data.label)) {
                lableValueObj[key].push(data.label)
              }
            }
          }
        })
        this.$emit('handleNodeCheck', { filterValueObj, lableValueObj, isInit })
      }
    },
    // 把选中的数据按照层级分级
    setScreenTreeCheckData (checkedList = []) {
      const list = []
      checkedList.forEach(item => {
        const index = item.level - 1
        if (list[index] === undefined) list[index] = []
        list[index].push(item)
      })
      this.screenLevelData = list
    },
    async getTreeData (isDefaultCheck = false) {
      this.isLoading = true
      this.currentNodeKey = -1
      this.tableData = {}
      const treeData = []
      this.id = 0
      const loadingLevel = this.screenInfo.loadingLevel
      const len = this.levelList.length
      const loadingNum = loadingLevel === 'all' ? len : loadingLevel === 'one' ? 1 : (len > 2 ? 2 : len)
      if (len > 0) {
        for (let index = 0; index < loadingNum; index++) {
          const config = this.levelList[index]
          const { field, fatherFilterList, dataInfo } = this.levelList[index]
          const title = dataInfo.datatype === 1 ? field.split('_')[0] : field.split('_')[1]
          const type = field.split('_')[2] // 当前表要使用的字段类型
          const data = await getData({ config: cloneDeep(config), loadingLevel, customDeskId: this.customDeskId, customData: this.customData, screenRefValue: this.screenRefInfoValue })
          data.forEach((item) => {
            let label = this.getLabel(item[title], type) 
            if (Array.isArray(label)) label = label.join()
            const obj = {
              id: this.id++,
              label: label,
              data: item,
              fieldValue: cloneDeep(item[title]),
              fieldType: type,
              datatype: dataInfo.datatype
            }
            // 全部加载的情况下要把没有子级的去掉
            if (loadingLevel === 'all') {
              obj.childrenIds = []
            }
            if (index === 0) {
              obj.level = index + 1
              obj.parentId = null
              // 第一级直接去重
              const treeIndex = treeData.findIndex(treeItem => { return label === treeItem.label })
              if (treeIndex === -1) {
                if (loadingLevel === 'all' || loadingLevel === 'two') {
                  obj.isGetData = true
                }
                treeData.push(obj)
              }
            } else {
              // 获取过滤条件
              const filterObj = {}
              if (Array.isArray(fatherFilterList)) {
                fatherFilterList.forEach(iten => {
                  let value = this.getLabel(item[iten.currentField.title] || item[iten.currentField.name], iten.currentField.type)  
                  filterObj[iten.fatherField] = value
                })
              }
              const i = treeData.findIndex(iter => {
                let flag = false
                if (iter.data && iter.level === index) {
                  flag = this.filterData(filterObj, iter)
                }
                return flag
              })
              if (i !== -1) {
                obj.level = index + 1
                obj.parentId = treeData[i].id
                const treeIndex = treeData.findIndex(treeItem => {
                  let flag = false
                  // 避免重复的数据
                  if (label === treeItem.label && obj.parentId === treeItem.parentId) {
                    flag = true
                  }
                  return flag
                })
                // treeIndex == -1 说明该数据不存在 需要添加进去
                if (treeIndex === -1) {
                  // isGetData 说明数据已经请求过了 展开的时候不需要再次请求数据
                  if (loadingLevel === 'all') {
                    obj.isGetData = true
                    treeData[i].childrenIds.push(obj.id)
                  }
                  if (obj.parentLable === undefined) obj.parentLable = treeData[i].parentLable ? [...treeData[i].parentLable] : []
                  obj.parentLable.push(treeData[i].label) // 记录一下上级的值
                  treeData.push(obj)
                }
              }
            }
          })
        }
      }
      if (loadingLevel === 'all') {
        // 去除不存在子级的节点
        const _treeData = cloneDeep(treeData)
        _treeData.forEach((item) => {
          // 最后一级的数据直接忽略
          if (item.level !== len && item.childrenIds.length === 0) {
            // 获取父级的index
            const parentIndex = treeData.findIndex(iten => { return item.parentId === iten.id })
            if (parentIndex !== -1 && treeData[parentIndex] && treeData[parentIndex].childrenIds) {
              // 获取在父级存贮的id的index
              const childrenIdsIndex = treeData[parentIndex].childrenIds.findIndex(id => { return id === item.id })
              // 删除在父级存贮的id、当父级存贮的id为空时，那这个父级就不显示
              treeData[parentIndex].childrenIds.splice(childrenIdsIndex, 1)
            }
          }
        })
      }
      this.treeData = this.createTree(treeData, loadingLevel)
      this.initTreeData = treeData
      await this.getTickList()
      if (isDefaultCheck) {
        this.setDefaultChecked()
        if (this.screenInfo.isAppenAll) {
          this.getAllOptionsQuery()
        }
      } else {
        this.$emit('handleNodeCheck', {filterValueObj: {}, lableValueObj: {}})
      }
      this.isLoading = false
    },
    getLabel (val, type) {
      if (Array.isArray(val) &&  val.length > 0) {
        if (['relation-user', 'roule', 'organization'].includes(type)) {
          const value = val[0]
          val = value.realname || value.name
        }
      }
      return val
    },
    // 判断本条数据是否符合过滤条件
    filterData (filterDataObj, treeData) {
      let flag = true
      for (const key in filterDataObj) {
        // key是在父级的title ，value是本条数据的值
        const fatherTitle = treeData.datatype === 1 ? key.split('_')[0] : key.split('_')[1]
        const type = key.split('_')[2]
        const label = this.getLabel(treeData.data[fatherTitle], type)
        // 有一个条件对不上就是不满足
        if (label !== filterDataObj[key]) {
          flag = false
        }
      }
      return flag
    },
    // 默认值设置勾选
    async setDefaultChecked () {
      this.defaultCheckedKeys = []
      this.checkList = []
      const lastLevel = this.levelList.length
      let defaultData = ''
      // 默认选择
      this.defaultSelected = this.screenInfo.defaultSelected
      if (this.screenInfo.isAppenAll === false && this.defaultSelected === undefined) {
        this.defaultSelected = 'null'
      } else if (this.screenInfo.isAppenAll === true && this.defaultSelected === undefined) {
        this.defaultSelected = 'all'
      }
      // all 展开第一级但是不要选中 null 自定义选中 first 选中第一条
      if (this.defaultSelected === 'null') {
        // 多选和默认自定义设置第一级的默认值
        if (this.screenInfo.filterMode === 'multiple') {
          this.screenInfo.value.forEach(item => {
            const node = this.treeData.find(iter => { return item === iter.label })
            if (node) {
              this.defaultCheckedKeys.push(node.id)
              this.checkList.push(node)
            }
          })
        }
        setTimeout(() => {
          this.setFilterObj(true, this.checkList, [])
        }, 10)
      } else if (this.defaultSelected === 'first' || this.defaultSelected === 'all') {
        if (this.screenInfo.loadingLevel === 'all') {
          this.treeForeach(this.treeData, async node => {
            if (node.level === lastLevel && defaultData === '') {
              defaultData = node.label
              // 展开节点
              this.currentNodeKey = node.id
              await this.$nextTick()
              this.$refs.tree.setCurrentKey(node.id);
              if (this.defaultSelected === 'first') {
                // 选中第一个走这边
                // 选择了全部 初始化的时候就不要勾选默认值了
                if (!this.screenInfo.checkAll) {
                  this.defaultCheckedKeys.push(node.id)
                  this.checkList.push(node)
                  setTimeout(() => {
                    const halfCheckedNodes = this.$refs.tree.getHalfCheckedNodes()
                    this.setFilterObj(false, [node], halfCheckedNodes)
                  }, 10)
                }
              }
              return
            }
          })
        } else if (this.screenInfo.loadingLevel === 'one') {
          // 一级加载走这里
          const node = this.treeData.find(item => item.id === 0)
          if (node) this.handleNodeExpand(node, true)
        } else {
          // 二级加载走这里
          const node = this.treeData.find(item => item.id === 0)
          if (node) {
            // 展开第一级
            if (this.defaultSelected) {
              this.currentNodeKey = node.id
              // 选中第一条
              if (this.defaultSelected === 'first' && node.children && node.children.length > 0) {
                const childrenNode = node.children[0]
                this.currentNodeKey = childrenNode.id
                if (!this.screenInfo.checkAll) {
                  this.defaultCheckedKeys.push(childrenNode.id)
                  this.checkList.push(childrenNode)
                }
                setTimeout(() => {
                  const halfCheckedNodes = this.$refs.tree.getHalfCheckedNodes()
                  this.setFilterObj(false, [childrenNode], halfCheckedNodes)
                }, 10)
              } else {
                this.$emit('handleNodeCheck', {filterValueObj: {}, lableValueObj: {}})
              }
              await this.$nextTick()
              this.$refs.tree.setCurrentKey(this.currentNodeKey);
            }
            const _node = node.children && node.children > 0 ? node.children[0] : node
            this.handleNodeExpand(_node, true)
          }  
        }
      }
    },
    // 获取全部选项的过滤条件
    getAllOptionsQuery () {
      const { filterList } = this.screenInfo
      if (filterList && filterList.length > 0) {
        const data = []
        this.treeForeach(this.treeData, async node => { data.push(node) })
        this.setFilterObj(false, data, [])
      }
    },
    // 遍历树结构
    treeForeach (tree, func) {
      tree.forEach(data => {
        data.children && this.treeForeach(data.children, func) // 遍历子树
        func(data)
      })
    },
    // 列表转树结构
    createLookup (list, loadingLevel) {
      const lookup = {}
      list.forEach(item => {
        let obj = { ...item, children: [] }
        if (loadingLevel === 'two' && item.level === 2 && this.levelList.length > 2) {
          obj.children = [{ label: '' }]
        }
        lookup[item.id] = obj
      })
      return lookup
    },
    createTree (list, loadingLevel) {
      const lookup = this.createLookup(list, loadingLevel)
      const tree = []
      for (const item of list) {
        if (item.parentId !== null) {
          if (loadingLevel !== 'all' || (item.childrenIds.length > 0 || item.level === this.levelList.length)) {
            lookup[item.parentId].children.push(lookup[item.id])
          }
        } else {
          if (loadingLevel === 'one') {
            lookup[item.id].children.push({ label: '' })
          }
          // 全部加载的情况下要去除没有子节点的数据
          if (loadingLevel !== 'all' || (item.childrenIds.length > 0 || item.level === this.levelList.length)) {
            tree.push(lookup[item.id])
          }
        }
      }
      return tree
    }
  },
  async mounted () {
    if (!this.isEdit) {
      await this.getTreeData(true)
    }
  }
}
</script>

<style lang="scss" scoped>
  .screen-tree {
    overflow: hidden;
    width: 100%;
  }
  ::v-deep .el-tree {
    .el-tree-node__content {
      min-height: 40px;
      height: fit-content;
    }
    .custom-tree-node {
      display: flex;
      // text-overflow: ellipsis;
      // overflow: hidden;
      flex: 1;
      padding-right: 5px;
      box-sizing: border-box;
    }
  }
  .tree-head {
    padding: 0 10px;
    display: flex;
    align-items: center;
    ::v-deep .el-input {
      width: 90%;
    }
    .el-icon-refresh-right {
      cursor: pointer;
      color: #4E86FF;
      margin-left: 8px;
      line-height: 32px;
      font-size: 24px;
    }
  }
</style>
